import { FormattedMessage } from 'react-intl';
import { FunctionRuntime } from '@rossum/api-client/hooks';
import { Stack, SvgIcon } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import {
  runtimesConfig,
  runtimeTypesConfig,
} from '../../extension-detail/config';

type Props = {
  onClick: () => void;
  runtime: FunctionRuntime;
  selected: boolean;
  dataCy: string;
};

export const RuntimeButton = ({
  onClick,
  runtime,
  selected,
  dataCy,
}: Props) => {
  const { type, translation } = runtimesConfig[runtime];
  const Icon = runtimeTypesConfig[type].icon;

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: 1,
        p: 1,
        borderWidth: 2,
        borderStyle: 'solid',
        borderRadius: borderRadius('m'),
        borderColor: t =>
          selected ? t.palette.primary.main : t.palette.action.hover,
        '&:hover': {
          borderColor: t =>
            selected ? t.palette.primary.main : t.palette.action.active,
        },
        backgroundColor: t =>
          selected ? t.palette.action.hover : 'transparent',
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        cursor: 'pointer',
      }}
      onClick={onClick}
      data-cy={dataCy}
    >
      <SvgIcon fontSize="medium">
        <Icon />
      </SvgIcon>
      <FormattedMessage id={translation} />
    </Stack>
  );
};
